<div class="center" [ngStyle]="{ color: color, fontSize: '12px' }">
  {{ deviceInfo.versionDisplay }}
</div>
